import React, { useState } from 'react';
import { Checkbox } from 'ui';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { ComplexValue } from 'app/types-shared';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { FavouriteAdminTranslation } from 'app/area/favourite-administration/constants';
import styles from './adjust-owners-modal.scss';

interface AdjustOwnersModalProps {
  addedOwners: ComplexValue<number>[];
  favouriteName: string;
  translation: FavouriteAdminTranslation;
  onClose: () => void;
  onSave: (applyOnDescendants: boolean) => void;
}

export const AdjustOwnersModal: React.FC<AdjustOwnersModalProps> = ({
  addedOwners, favouriteName, translation, onClose, onSave
}) => {
  const [applyOnDescendants, setApplyOnDescendants] = useState(true);

  const onApplyOnDescendants = (value: number) => {
    setApplyOnDescendants(!!value);
  };

  return (
    <ModalWrapper
      headerTitle={translation.owners_apply_on_descendants_modal_title}
      btnTitle={translation.update_button}
      btnCancelTitle={translation.cancel}
      onClose={onClose}
      onDone={() => onSave(applyOnDescendants)}>

      {addedOwners?.length > 0 && <>
        <p className="mb-0">{translation.owners_apply_on_descendants_modal_add_description}</p>
        <ul className={styles.ownerList}>
          {addedOwners
            .filter(owner => owner.description)
            .map(owner => <li key={owner.value}>{owner.description}</li>)}
        </ul></>}

      <p>
        {replaceTemplateString(
          translation.owners_apply_on_descendants_modal_sub_description,
          favouriteName
        )}
      </p>
      <Checkbox
        componentId={undefined}
        className={undefined}
        value={applyOnDescendants ? 1 : 0}
        label={{ text: translation.owners_apply_on_descendants_modal_checkbox, visible: true }}
        onChange={onApplyOnDescendants}
      />
    </ModalWrapper>
  );
};
